import { Form } from "react-bootstrap"
import { useEffect,useState } from "react"
export default function Input ({type,name,min,max,onChange,label,className,id,value,focus,readOnly,defalut,required=true,placeholder='',disabled=false}) {
    const displayLabel = label && label.length > 0 ? label.charAt(0).toUpperCase() + label.slice(1) : label;
    return (
      <>
          <Form.Group className={className} id={id}>
                  <Form.Label className='fw-medium'> {required ? <>{displayLabel} <span style={{color:'red'}}>*</span></> : <>{displayLabel}</>}</Form.Label>
                    <Form.Control
                      className={className}
                      size='md'
                      step={type==="number" ? 0.01 :null }
                      readOnly={readOnly}
                      min={min}
                      autoFocus={focus}
                      required = {required}
                      value={value}
                      defaultValue={defalut}
                      max={max}
                      type={type}
                      name={name}
                      placeholder= {placeholder}
                      onChange={onChange}
                      disabled={disabled}
                      as = {type === 'textarea' ? 'textarea' : 'input'}
                      rows = {type === 'textarea' ? 3 : null}
                    />
          </Form.Group>
      </>
    )
  }

export  function InputF ({type,name,onChange,label,className,id,message,required,value,ref, accept='.pdf'}) {
    const displayLabel = label && label.length > 0 ? label.charAt(0).toUpperCase() + label.slice(1) : label;
    return (
        <>
            <Form.Group className={className} >
                <Form.Label className='fw-medium'>{required ? <>{displayLabel} <span style={{color:'red'}}>*</span></> : <>{displayLabel}</>}</Form.Label>
                    <Form.Control
                        className={className}
                        size='md'
                        id={id}
                        ref={ref}
                        value={value}
                        accept={accept}
                        type={type}
                        name={name}
                        required = {required}
                        placeholder={label && label.length > 0 ? label.charAt(0).toUpperCase() + label.slice(1) : label}
                        onChange={onChange}
                    />
            </Form.Group>
        </>
    )
}

export function InputT ({type,name,min,max,onChange,label,className,id,defalut,value}) {
    const displayLabel = label && label.length > 0 ? label.charAt(0).toUpperCase() + label.slice(1) : label;
    return (
      <>
          <Form.Group className={className} id={id}>
                  <Form.Label className='fw-medium'>{displayLabel}</Form.Label>
                    <Form.Control
                      className={className}
                      size='md'
                      required
                      min={min}
                      max={max}
                      value={value}
                      defaultValue={defalut}
                      type={type}
                      name={name}
                      placeholder={label && label.length > 0 ? label.charAt(0).toUpperCase() + label.slice(1) : label}
                      onChange={onChange}
                    />
          </Form.Group>
      </>
    )
  }

export function InputCheckbox ({value, label, onChange, name='L1'}) {
    return (
      <Form.Check 
      inline
      type='radio'
      id={`default-checkbox}`}
      value={value}
      name={name}
      onChange={onChange}
      label={`${label}`}
    />
    )
}
export function InputRadio ({value, label, onChange,name='L1',disabled=false,checked=false}) {
    return (
      <Form.Check 
      inline
      type='radio'
      id={`default-checkbox}`}
      value={value}
      checked={checked}
      name={name}
      disabled={disabled}
      onChange={onChange}
      label={`${label}`}
    />
    )
}
export function InputCheckB ({value, label, onChange,name='Lm1',checked=false}) {
    return (
      <Form.Check 
      type='checkbox'
      id={`default-checkbox}`}
      value={value}
      name={name}
      onChange={onChange}
      checked={checked}
      label={`${label}`}
    />
    )
}

export const InputCheck = () => {
    const [selectedCount, setSelectedCount] = useState(0);
    const [selectedOptions, setSelectedOptions] = useState([]);
  
    const handleCheckboxChange = (e) => {
      const isChecked = e.target.checked;
      const newCount = isChecked ? selectedCount + 1 : selectedCount - 1;
      const optionValue = e.target.value;
  
      if (newCount <= 3) {
        setSelectedCount(newCount);
        if (isChecked) {
          setSelectedOptions([...selectedOptions, optionValue]);
        } else {
          setSelectedOptions(selectedOptions.filter(option => option !== optionValue));
        }
      } else {
        e.target.checked = false;
      }
    };
    useEffect(() => {
      console.log(selectedOptions)
    }, [selectedOptions])
  
    return (
      <div>
        <InputCheckbox value="HEEG" label="HEEG" onChange={handleCheckboxChange}/>
        <InputCheckbox value="ESTI" label="ESTI" onChange={handleCheckboxChange}/>
        <InputCheckbox value="ES2A" label="ES2A" onChange={handleCheckboxChange}/>
        <InputCheckbox value="ESMGE" label="ESMGE" onChange={handleCheckboxChange}/>
        <InputCheckbox value="ESU2A" label="ESU2A" onChange={handleCheckboxChange}/>
      </div>
    );
  };
  export function InputOption ({value,label}) {
    return (
      <option value={value}>{label}</option> 
    )
  }